import HttpClient from 'HttpClient'
import apiRoutes from '../../Routes/Routes.json'

const saveControlReportingRules = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.ControlReportingRules.saveControlReportingRules}`,
    queryModel,
  )
}

const getControlReportingRules = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.ControlReportingRules.getControlReportingRules}`,
    queryModel,
  )
}

const ControlReportingRuleService = {
  saveControlReportingRules,
  getControlReportingRules
}

export default ControlReportingRuleService
 